export default "/images/vendor/@coreui/icons/svg/flag/cif-ml.svg?d83fd691ed7f565d0e1e52da66850df0";